var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarbadosFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_2845_1587)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9567 1.58763C20.8532 0.5705 18.4933 0 16.0002 0C13.507 0 11.1472 0.5705 9.04366 1.58763L7.65234 16L9.04366 30.4124C11.1472 31.4295 13.507 32 16.0002 32C18.4933 32 20.8532 31.4295 22.9567 30.4124L24.348 16L22.9567 1.58763Z",
    fill: "#FFDA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 1.58813C3.69163 4.17601 0 9.65657 0 15.9999C0 22.3433 3.69163 27.8239 9.0435 30.4118V1.58813Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 1.58813V30.4118C28.3084 27.8239 32 22.3433 32 15.9999C32 9.65664 28.3084 4.17601 22.9565 1.58813Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8697 9.73921L19.9363 9.27259C19.8801 9.38515 18.6614 11.8647 18.4623 15.6523H17.0436V9.73921L16.0001 8.3479L14.9566 9.73921V15.6523H13.538C13.3388 11.8647 12.1202 9.38515 12.0639 9.27259L10.1973 10.2059C10.2101 10.2315 11.4785 12.8131 11.4785 16.6958V17.7393H14.9567V23.6523H17.0436V17.7393H20.5219V16.6957C20.5219 14.6883 20.8692 13.0331 21.1606 11.998C21.4783 10.8692 21.801 10.21 21.8042 10.2035L20.8697 9.73921Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2845_1587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbadosFlag);
export default __webpack_public_path__ + "static/media/barbados-flag.c7e1558628205dd1473cf82b25bce3e0.svg";
export { ForwardRef as ReactComponent };